<div (click)="sortService.setCurrentSortField(sortObjectId, sortField)" class="pointer text-nowrap"><ng-content></ng-content>
  <ng-container [ngSwitch]="sortService.getCurrentSortIconClass(sortObjectId, sortField)">
      <span *ngSwitchDefault class="ps-2"><i class="sort-hidden"></i></span>
      <span *ngSwitchCase="'ASC'" class="ps-2"><i class="fas fa-caret-down"></i></span>
      <span *ngSwitchCase="'DESC'" class="ps-2"><i class="fas fa-caret-up"></i></span>
  </ng-container>
</div>